import { QueryClient } from "@tanstack/react-query";
import { API_BASE_URL } from "../../config.js";
import api from "../http.js";
export const queryClient = new QueryClient();

export async function fetchProcessedReservation({
  date,
  query,
  page = 1,
  pageSize = 12,
}) {
  // const token = customerToken;
  const response = await api.get(
    `/customer_service/api/reservations/?date=${date}&query=${query}&page=${page}&page_size=${pageSize}`,
  );

  const houses = await response.data;

  return {
    results: houses.results,
    totalCount: houses.count,
    next: houses.next,
    previous: houses.previous,
  };
}

export async function fetchReservationPayment({ page = 1, pageSize = 12 }) {
  // const token = customerToken;
  const response = await api.get(
    `/customer_service/api/reservations/payment_transaction/?page=${page}&page_size=${pageSize}`,
  );

  const reservation = await response.data;

  return {
    results: reservation.results,
    totalCount: reservation.count,
    next: reservation.next,
    previous: reservation.previous,
  };
}

export async function fetchDepositHistory({ page = 1, pageSize = 12 }) {
  const response = await api.get(
    `/customer_service/api/deposit_transaction/?page=${page}&page_size=${pageSize}`,
  );

  const deposit = await response.data;

  return {
    results: deposit.results,
    totalCount: deposit.count,
    next: deposit.next,
    previous: deposit.previous,
  };
}

export async function fetchCustomerList({
  searchText,
  page = 1,
  pageSize = 12,
}) {
  const response = await api.get(
    `/customer_service/api/customer_profile/?query=${searchText}&page=${page}&page_size=${pageSize}`,
  );

  const customer = await response.data;

  return {
    results: customer.results,
    totalCount: customer.count,
    next: customer.next,
    previous: customer.previous,
  };
}

export async function fetchPaymentRequest({
  searchText,
  page = 1,
  pageSize = 12,
}) {
  const response = await api.get(
    `${API_BASE_URL}/customer_service/api/payment_request/?query=${searchText}&page=${page}&page_size=${pageSize}`,
  );

  const payment = await response.data;

  return {
    results: payment.results,
    totalCount: payment.count,
    next: payment.next,
    previous: payment.previous,
  };
}

export async function fetchCustomerProfile() {
  const response = await api.get(
    `${API_BASE_URL}/customer_service/api/customer_profile/`,
  );

  const profile = await response.data;
  return profile;
}

export async function fetchReservations({ id, page = 1, pageSize = 12 }) {
  const response = await api.get(
    `/customer_service/api/reservations/host/${id}/?page=${page}&page_size=${pageSize}`,
  );

  const reservations = await response.data;

  return {
    results: reservations.results,
    totalCount: reservations.count,
    next: reservations.next,
    previous: reservations.previous,
  };
}

export async function fetchDepositTransaction({ id, page = 1, pageSize = 12 }) {
  const response = await api.get(
    `${API_BASE_URL}/customer_service/api/deposit_transaction/host/${id}/?page=${page}&page_size=${pageSize}`,
  );

  const transaction = await response.data;

  return {
    results: transaction.results,
    totalCount: transaction.count,
    next: transaction.next,
    previous: transaction.previous,
  };
}

export async function fetchCommissionHistory({ id, page = 1, pageSize = 12 }) {
  const response = await api.get(
    `/customer_service/api/commission_history/host/${id}/?page=${page}&page_size=${pageSize}`,
  );

  const commission = await response.data; 

  return {
    results: commission.results || [],
    totalCount: commission.count || 0,
    next: commission.next,
    previous: commission.previous,
  };
}

export async function filterHouseList({ filters, page = 1, pageSize = 12 }) {
  const response = await api.post(
    `/customer_service/api/filter_house_for_user/?page=${page}&page_size=${pageSize}`,
    filters,
  );
  return response.data;
}

// ----- Reservation List table ------

export async function fetchReservation({
  searchText,
  page = 1,
  pageSize = 12,
}) {
  const response = await api.get(
    `/customer_service/api/reservation_request_list/?search=${searchText}&page=${page}&page_size=${pageSize}`,
  );

  const reserve = await response.data;

  return {
    results: reserve.results,
    totalCount: reserve.count,
    next: reserve.next,
    previous: reserve.previous,
  };
}

// ------ POST Reservation ---------

export async function postResevation(fields) {
  const response = await api.post(
    `/customer_service/api/reserve_house/`,
    fields,
  );
  return response.data;
}

// ********** GET Dashboard stats *********

export async function fetchDashboardStats() {
  const response = await api.get("/customer_service/api/dashboard_stats/");
  return response.data;
}

// *********** | Customer REPORT *********

export async function fetchCustomerServiceReport({startDate, endDate, period, search, id, page = 1, pageSize = 10 }) {
  const response = await api.get(
    `/customer_service/api/customer_report/?start_date=${startDate}&end_date=${endDate}&period=${period}&customer_id=${id}&search=${search}&page=${page}&page_size=${pageSize}`,
  );
  const customerReports = await response.data;
  return customerReports;
}

